import { Str } from '@/modules/util/string'
import { getAppBarData } from '@/modules/appBarCache'

type TNavItemData = {
  code: String
  name: string
  img: string
  imgHover: string | undefined
  appId: string | undefined
  route: string | undefined
}

export const navItems = async () => {
  try {
    const result = await getAppBarData()
    let navItems: TNavItemData[] = []

    if (!result) {
      return navItems
    }

    Object.keys(result).forEach(key => {
      const item = result[key]
      let navItemData: any = {
        code: Str.camelToSnake(key),
        name: item.label,
        img: '/images/app_bar/' + item.appImage,
        imgHover: '/images/app_bar/' + item.appImageHover
      }

      // Handle local redirects
      if (item.appDetails.ssoType === 6) {
        navItemData['route'] = item.appDetails.landingUrl
      } else {
        navItemData['appId'] = item.appId
      }

      if (item.showButton) {
        navItems.push(navItemData)
      }
    })

    return navItems
  } catch (error) {
    console.error('NavData: Error fetching app bar data:', error)
    return []
  }
}
